import * as Yup from 'yup';

export const numberFieldValidator = Yup.number()
  .typeError('Must be a postive number')
  .positive('Must be a positive number');

/**
 * Validator for number fields that are able to be empty
 * The value is only treated as a number if it's not empty
 */
export const optionalNumberFieldValidator = Yup.lazy(value =>
  value === '' ? Yup.string().optional() : numberFieldValidator.optional()
);

export const requiredNumberFieldValidator = numberFieldValidator.required('Field is required');
